<script setup lang="ts">
import type { Schemas } from "#shopware";
import {
  getCategoryRoute,
  getTranslatedProperty,
} from "@shopware/helpers";

const {navigationElement} = defineProps<{
  navigationElement: Schemas["Category"];
  height: number;
}>();

const areChildrenVisible = ref(false);

const backgroundColor = computed<string>(() => navigationElement?.translated?.customFields?.category_name_background_color || '#ffffff')
const textColor = computed<string>(() => navigationElement?.translated?.customFields?.category_name_text_color || '#344854')
</script>

<template>
  <div class="w-full p-2 uppercase">
    <div class="flex justify-between gap-2">
      <NuxtLink :to="getCategoryRoute(navigationElement)" class="flex-1">
        <div :class="[`bg-[${backgroundColor}]`, `text-[${textColor}]`, 'px-4 py-2 rounded-full w-fit']">
          {{ getTranslatedProperty(navigationElement, "name") }}
        </div>
      </NuxtLink>

      <button
        v-if="navigationElement?.childCount"
        class="pi pi-angle-right text-xl"
        @click="areChildrenVisible = !areChildrenVisible"
      />
    </div>
  </div>

  <Transition
    enter-active-class="animate-fadeinleft"
    leave-active-class="animate-fadeoutleft"
  >
    <div
      v-if="areChildrenVisible"
      class="flex flex-col absolute h-full w-full top-0 bg-white dark:bg-surface-900 shadow left-0 divide-y"
    >
      <button
        class="flex w-full p-4 items-center gap-2 -mt-1"
        @click.stop="areChildrenVisible = false"
      >
        <span class="pi pi-angle-left text-xl" />
        <span>{{ getTranslatedProperty(navigationElement, "name") }}</span>
      </button>

      <NavigationElement
        v-for="child in navigationElement.children"
        :key="child.id"
        :navigation-element="child"
        :height="height"
      />
    </div>
  </Transition>
</template>
